import { Subscription } from 'rxjs';

/**
 * The app root's hardware-back handler (kzd r1 REVIEW-WI-rest-10 #1, DESIGN §16 item 26).
 *
 * It was a plain `platform.backButton.subscribe(() => exitApp())`: a plain subscription runs on EVERY `ionBackButton`
 * and ignores priorities, so on Android the back button closed the app even where a screen had claimed it — the locked
 * restaurant kiosk (priority 10) among them, and a cold start is not sent back to the kiosk. Ionic's documented
 * pattern: register at priority −1 (below the router outlet's 0 and every screen's own handler) and exit only when the
 * outlet has nothing to go back to. A higher handler that does not call `next()` therefore stops it.
 */
export const APP_EXIT_BACK_PRIORITY = -1;

/** The slice of Ionic's `Platform.backButton` this needs. */
export interface BackButtonSource {
  subscribeWithPriority(priority: number, callback: (processNextHandler: () => void) => Promise<unknown> | void): Subscription;
}

export function registerAppExit(backButton: BackButtonSource, canGoBack: () => boolean, exit: () => void): Subscription {
  return backButton.subscribeWithPriority(APP_EXIT_BACK_PRIORITY, () => {
    if (!canGoBack()) {
      exit();
    }
  });
}
